export enum FontSizeEnum {
  // heading
  H1 = '3rem',
  H2 = '2.6rem',
  H3 = '2.4rem',
  H4 = '2.2rem',
  H5 = '2rem',
  H6 = '1.8rem',

  // body
  Body1 = '1.6rem',
  Body2 = '1.5rem',
  Body3 = '1.4rem',
  Body4 = '1.3rem',
  Body5 = '1.2rem',

  // caption
  Caption1 = '1.2rem',
  Caption2 = '1.1rem',
}
